import cep from './cep'
import cnpj from './cnpj'
import document from './document'
import convertBinaryToBool from './convertBinaryToBool'
import convertBoolToBinary from './convertBoolToBinary'
import convertBoolToString from './convertBoolToString'
import cpf from './cpf'
import creditCards from './creditCards'
import currencyInput from './currencyInput'
import currencyOutput from './currencyOutput'
import date from './date'
import dateFromNow from './dateFromNow'
import dates from './dates'
import dateTime from './dateTime'
import errorMessage from './errorMessage'
import file from './file'
import float from './float'
import floatToMoney from './floatToMoney'
import formatByNameInFilter from './formatByNameInFilter'
import getIdFromObject from './getIdFromObject'
import hours from './hours'
import multipleParagraphs from './multipleParagraphs'
import onlyNumbersFloat from './onlyNumbersFloat'
import percentage from './percentage'
import phone from './phone'
import regex from './regex'
import regularizeCurrency from './regularizeCurrency'
import website from './website'

const formatters = {
  cep,
  cnpj,
  document,
  convertBinaryToBool,
  convertBoolToBinary,
  convertBoolToString,
  cpf,
  creditCards,
  currencyInput,
  currencyOutput,
  date,
  dateFromNow,
  dates,
  dateTime,
  errorMessage,
  file,
  float,
  floatToMoney,
  formatByNameInFilter,
  getIdFromObject,
  hours,
  multipleParagraphs,
  onlyNumbersFloat,
  percentage,
  phone,
  regex,
  regularizeCurrency,
  website,
}

export default formatters
